var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJ1772Plug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 68,
    viewBox: "0 0 64 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_19200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0411 59.7061C16.774 59.7061 4.35651 47.2268 4.35651 31.8831C4.35651 16.5395 16.7788 4.06012 32.0411 4.06012C47.3033 4.06012 59.7256 16.5395 59.7256 31.8831C59.7256 47.2268 47.3033 59.7061 32.0411 59.7061ZM32.0411 4.61465C17.0831 4.61465 4.91194 16.8433 4.91194 31.8831C4.91194 46.923 17.0831 59.1516 32.0411 59.1516C46.999 59.1516 59.1702 46.923 59.1702 31.8831C59.1702 16.8433 46.999 4.61465 32.0411 4.61465Z",
    fill: "#88D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0411 59.7495C47.3548 59.7495 59.7691 47.2733 59.7691 31.8831C59.7691 16.4929 47.3548 4.01672 32.0411 4.01672C16.7273 4.01672 4.31304 16.4929 4.31304 31.8831C4.31304 47.2733 16.7273 59.7495 32.0411 59.7495Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6163 12.1466C46.603 7.1221 39.6818 4.0119 32.0411 4.0119C20.8745 4.0119 11.2583 10.647 6.86319 20.209C7.64562 22.9142 9.48095 25.3782 11.7655 27.09C15.1898 29.6457 19.4642 30.7789 23.6758 31.4974C28.3221 32.2882 33.1181 32.6354 37.7354 31.6951C42.3527 30.7548 46.8155 28.4209 49.6216 24.6405C52.249 21.1059 53.2005 16.2212 51.6163 12.1466Z",
    fill: "#31404C"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4216 24.6887C58.4216 39.1402 46.6899 50.8529 32.2149 50.8529C17.74 50.8529 6.00831 39.1402 6.00831 24.6887C6.00831 23.6905 6.0711 22.702 6.17735 21.7328C5.03269 24.7899 4.39998 28.0978 4.39998 31.56C4.39998 46.9519 16.8126 59.4264 32.128 59.4264C47.4434 59.4264 59.856 46.9519 59.856 31.56C59.856 28.3534 59.3102 25.2721 58.3153 22.4079C58.3781 23.1601 58.4216 23.922 58.4216 24.6887Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.3778 44.2419C38.3778 47.7331 35.5427 50.5636 32.0459 50.5636C28.5491 50.5636 25.714 47.7331 25.714 44.2419C25.714 40.7508 28.5491 37.9203 32.0459 37.9203C35.5427 37.9203 38.3778 40.7508 38.3778 44.2419Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6126 63.1732C25.8734 63.2214 27.53 63.5445 27.5348 63.4191L27.8101 59.1468L25.7478 58.6839C13.1516 55.7473 3.99427 44.2371 4.51106 30.8512C5.09547 15.6764 17.8945 3.84797 33.094 4.43143C48.2934 5.01489 60.141 17.7932 59.5566 32.9681C59.0639 45.7223 49.95 56.1089 38.03 58.7514L38.0639 63.2455C38.0639 63.2455 37.8562 63.2793 37.8562 63.2841C52.2442 60.6368 63.3915 48.3358 63.9807 33.132C64.6569 15.5317 50.9064 0.704015 33.263 0.0241113C15.6245 -0.655792 0.772779 13.0725 0.0917738 30.6873C-0.516784 46.5276 10.5435 60.1112 25.6126 63.178V63.1732Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2591 68H35.7842C37.2621 68 38.4599 66.8041 38.4599 65.3286V59.5277L38.03 58.7562C38.03 58.7562 35.6634 59.4457 33.065 59.5277C30.2637 59.6193 27.8101 59.1468 27.8101 59.1468L26.5834 60.2366V65.3286C26.5834 66.8041 27.7812 68 29.2591 68Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.38526 15.522C15.9191 -3.6117 43.7679 -5.21743 57.3831 12.9423C59.1943 15.3581 60.595 18.0632 61.5754 20.8986C59.175 15.4497 55.3643 10.6422 50.5296 7.17514C35.4026 -3.67439 14.7261 0.433967 5.38526 15.522Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2602 62.9321C3.4968 57.6327 -7.6118 32.457 5.95035 13.7331C7.73256 11.298 9.73693 8.75677 12.1277 6.9437C7.68909 10.917 4.37583 16.3659 2.59362 22.0318C-3.18285 39.907 7.48141 58.0522 24.2554 62.9321H24.2602Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3116 8.02383C69.1872 22.3982 67.2601 50.1393 46.5016 60.3668C43.7872 61.688 41.4399 62.4113 38.6724 63.0237C44.5793 61.7169 49.0903 58.4717 53.3164 54.291C66.7916 41.18 65.8547 20.1657 53.3116 8.02383Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6051 38.687C54.8137 58.2017 31.3939 67.0452 15.6293 54.8696C13.5815 53.2687 11.7365 51.4123 10.2392 49.305C13.538 53.2302 17.851 56.2921 22.6857 57.9798C37.9334 63.4384 54.5336 54.1946 58.6003 38.6822L58.6051 38.687Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6363 24.2949C29.4451 20.8736 27.3228 17.4454 23.8959 16.6379C20.4691 15.8304 17.0354 17.9493 16.2266 21.3706C15.4177 24.792 17.5401 28.2201 20.967 29.0276C24.3938 29.8351 27.8275 27.7162 28.6363 24.2949Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.5856 28.7186C47.8386 27.3733 49.3833 23.65 48.0359 20.4022C46.6885 17.1545 42.9591 15.6122 39.7061 16.9575C36.4531 18.3027 34.9083 22.0261 36.2558 25.2738C37.6032 28.5216 41.3326 30.0638 44.5856 28.7186Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5022 49.9026C38.9919 47.4169 38.9919 43.3868 36.5022 40.9011C34.0125 38.4153 29.9758 38.4153 27.4861 40.9011C24.9963 43.3868 24.9963 47.4169 27.4861 49.9026C29.9758 52.3883 34.0125 52.3883 36.5022 49.9026Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4403 43.644C20.865 43.644 22.8306 41.6816 22.8306 39.2608C22.8306 36.84 20.865 34.8776 18.4403 34.8776C16.0156 34.8776 14.05 36.84 14.05 39.2608C14.05 41.6816 16.0156 43.644 18.4403 43.644Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1986 43.6365C49.4388 42.7102 50.5026 40.1461 49.5747 37.9096C48.6468 35.6731 46.0786 34.611 43.8384 35.5374C41.5983 36.4638 40.5345 39.0279 41.4624 41.2644C42.3903 43.5009 44.9585 44.5629 47.1986 43.6365Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.9796 21.6798C25.9796 23.1649 24.7722 24.3704 23.2846 24.3704C21.797 24.3704 20.5896 23.1649 20.5896 21.6798C20.5896 20.1946 21.797 18.9891 23.2846 18.9891C24.7722 18.9891 25.9796 20.1946 25.9796 21.6798Z",
    fill: "url(#paint0_linear_6_19200)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2363 15.4111C19.8602 15.4111 17.1266 18.2417 17.1266 21.7328C17.1266 25.2239 19.8651 28.0544 23.2363 28.0544C26.6075 28.0544 29.346 25.2239 29.346 21.7328C29.346 18.2417 26.6123 15.4111 23.2363 15.4111ZM23.2363 25.7206C21.1063 25.7206 19.3821 23.9364 19.3821 21.7328C19.3821 19.5291 21.1063 17.745 23.2363 17.745C25.3662 17.745 27.0905 19.5291 27.0905 21.7328C27.0905 23.9364 25.3662 25.7206 23.2363 25.7206Z",
    fill: "#4F6B77"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2791 16.4816C26.453 16.5925 26.6413 16.7661 26.6027 16.9687C26.5689 17.1326 26.3902 17.2339 26.2211 17.2387C26.0521 17.2387 25.8927 17.176 25.7333 17.1181C24.5742 16.6793 23.2749 16.6167 22.082 16.9542C21.6956 17.0603 20.5606 17.1808 21.0387 16.4575C21.3333 16.0139 22.2365 15.8548 22.7195 15.7776C23.9366 15.5751 25.2358 15.8114 26.2743 16.4865L26.2791 16.4816Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9605 19.8377C25.0378 19.9004 25.1151 19.9872 25.0861 20.0837C25.062 20.1608 24.975 20.1994 24.8929 20.1897C24.8156 20.1849 24.7432 20.1415 24.6708 20.1078C24.1491 19.8426 23.5406 19.7461 22.9658 19.8426C22.7823 19.8715 22.2414 19.8715 22.5022 19.5581C22.6615 19.3652 23.0962 19.3363 23.3281 19.3266C23.9076 19.2929 24.5065 19.4713 24.9605 19.8377Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6514 26.3812C25.3421 26.1015 26.3564 25.4023 26.2791 25.0889C26.0376 24.5151 25.3131 25.2722 24.8495 25.4506C23.8932 25.8267 22.9707 25.9328 22.2558 25.7206C21.1498 25.3975 20.4543 24.5874 20.2515 24.9153C19.7733 25.7351 22.4152 27.2878 24.6514 26.3812Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0139 24.0233C24.3713 23.8786 24.8929 23.517 24.8543 23.353C24.7287 23.054 24.3568 23.4446 24.1153 23.5411C23.6227 23.7339 23.1445 23.787 22.7775 23.6809C22.2075 23.5121 21.8453 23.0974 21.7439 23.2662C21.4976 23.6905 22.8644 24.491 24.0187 24.0233H24.0139Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.8932 21.6798C44.8932 23.1649 43.6858 24.3704 42.1982 24.3704C40.7106 24.3704 39.5031 23.1649 39.5031 21.6798C39.5031 20.1946 40.7106 18.9891 42.1982 18.9891C43.6858 18.9891 44.8932 20.1946 44.8932 21.6798Z",
    fill: "url(#paint1_linear_6_19200)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1451 15.4111C38.769 15.4111 36.0353 18.2417 36.0353 21.7328C36.0353 25.2239 38.769 28.0544 42.1451 28.0544C45.5211 28.0544 48.2548 25.2239 48.2548 21.7328C48.2548 18.2417 45.5163 15.4111 42.1451 15.4111ZM42.1451 25.7206C40.0151 25.7206 38.2909 23.9364 38.2909 21.7328C38.2909 19.5291 40.0151 17.745 42.1451 17.745C44.275 17.745 45.9993 19.5291 45.9993 21.7328C45.9993 23.9364 44.275 25.7206 42.1451 25.7206Z",
    fill: "#4F6B77"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1878 16.4816C45.3617 16.5925 45.5501 16.7661 45.5114 16.9687C45.4776 17.1326 45.2989 17.2339 45.1299 17.2387C44.9608 17.2387 44.8015 17.176 44.6421 17.1181C43.4829 16.6793 42.1837 16.6167 40.9907 16.9542C40.6043 17.0603 39.4693 17.1808 39.9475 16.4575C40.2421 16.0139 41.1453 15.8548 41.6283 15.7776C42.8454 15.5751 44.1446 15.8114 45.183 16.4865L45.1878 16.4816Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8741 19.8377C43.9514 19.9004 44.0287 19.9872 43.9997 20.0837C43.9756 20.1608 43.8886 20.1994 43.8065 20.1897C43.7292 20.1849 43.6568 20.1415 43.5843 20.1078C43.0627 19.8426 42.4542 19.7461 41.8794 19.8426C41.6959 19.8715 41.1549 19.8715 41.4158 19.5581C41.5751 19.3652 42.0098 19.3363 42.2417 19.3266C42.8212 19.2929 43.4201 19.4713 43.8741 19.8377Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.565 26.3812C44.2557 26.1015 45.27 25.4023 45.1927 25.0889C44.9512 24.5151 44.2267 25.2722 43.7631 25.4506C42.8067 25.8267 41.8842 25.9328 41.1694 25.7206C40.0634 25.3975 39.3679 24.5874 39.1651 24.9153C38.6869 25.7351 41.3288 27.2878 43.565 26.3812Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9226 24.0233C43.2801 23.8786 43.8017 23.517 43.763 23.353C43.6375 23.054 43.2656 23.4446 43.0241 23.5411C42.5314 23.7339 42.0533 23.787 41.6862 23.6809C41.1163 23.5121 40.7541 23.0974 40.6526 23.2662C40.4063 23.6905 41.7731 24.491 42.9275 24.0233H42.9226Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.7042 38.1903C47.7042 39.2222 46.8686 40.0565 45.835 40.0565C44.8015 40.0565 43.9659 39.2222 43.9659 38.1903C43.9659 37.1584 44.8015 36.3242 45.835 36.3242C46.8686 36.3242 47.7042 37.1584 47.7042 38.1903Z",
    fill: "url(#paint2_linear_6_19200)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.7964 33.8361C43.4539 33.8361 41.5558 35.7986 41.5558 38.2241C41.5558 40.6496 43.4539 42.6121 45.7964 42.6121C48.1389 42.6121 50.037 40.6496 50.037 38.2241C50.037 35.7986 48.1389 33.8361 45.7964 33.8361ZM45.7964 40.9919C44.3185 40.9919 43.1207 39.7527 43.1207 38.2241C43.1207 36.6955 44.3185 35.4563 45.7964 35.4563C47.2743 35.4563 48.4721 36.6955 48.4721 38.2241C48.4721 39.7527 47.2743 40.9919 45.7964 40.9919Z",
    fill: "#4F6B77"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.907 34.5786C48.0278 34.6558 48.1582 34.7763 48.1292 34.9162C48.1051 35.0319 47.9843 35.0994 47.8636 35.1042C47.7476 35.1042 47.6366 35.0608 47.5255 35.0174C46.7237 34.7137 45.8206 34.6703 44.9898 34.9017C44.7242 34.974 43.9369 35.0608 44.2653 34.5593C44.4682 34.2507 45.0961 34.1447 45.4342 34.0868C46.2794 33.947 47.1777 34.1109 47.9022 34.5786H47.907Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9942 36.9077C47.0473 36.9511 47.1005 37.0138 47.0811 37.0764C47.0666 37.1295 47.0039 37.1536 46.9459 37.1536C46.8928 37.1536 46.8396 37.1198 46.7913 37.0957C46.4291 36.9125 46.0089 36.845 45.608 36.9125C45.4776 36.9318 45.1057 36.9318 45.2844 36.7148C45.3955 36.5798 45.695 36.5605 45.8544 36.5508C46.2601 36.5267 46.6706 36.6521 46.9894 36.9077H46.9942Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.7817 41.45C47.2598 41.2571 47.965 40.7701 47.9119 40.5531C47.7476 40.1529 47.2405 40.6785 46.9217 40.8039C46.2601 41.0643 45.6177 41.1366 45.1202 40.9919C44.3523 40.7653 43.8693 40.2059 43.7292 40.4326C43.4008 41.0016 45.2313 42.0769 46.7817 41.45Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3373 39.8154C46.5837 39.7141 46.9507 39.4633 46.9218 39.3524C46.8348 39.1451 46.574 39.4151 46.4098 39.4826C46.0669 39.6176 45.7384 39.6562 45.4825 39.5791C45.0864 39.4633 44.8353 39.174 44.7628 39.2898C44.5938 39.5839 45.5404 40.1384 46.3422 39.8154H46.3373Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.8987 38.1903C20.8987 39.2222 20.0631 40.0565 19.0295 40.0565C17.9959 40.0565 17.1604 39.2222 17.1604 38.1903C17.1604 37.1584 17.9959 36.3242 19.0295 36.3242C20.0631 36.3242 20.8987 37.1584 20.8987 38.1903Z",
    fill: "url(#paint3_linear_6_19200)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9957 33.8361C16.6532 33.8361 14.7551 35.7986 14.7551 38.2241C14.7551 40.6496 16.6532 42.6121 18.9957 42.6121C21.3382 42.6121 23.2363 40.6496 23.2363 38.2241C23.2363 35.7986 21.3382 33.8361 18.9957 33.8361ZM18.9957 40.9919C17.5178 40.9919 16.32 39.7527 16.32 38.2241C16.32 36.6955 17.5178 35.4563 18.9957 35.4563C20.4736 35.4563 21.6714 36.6955 21.6714 38.2241C21.6714 39.7527 20.4736 40.9919 18.9957 40.9919Z",
    fill: "#4F6B77"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1063 34.5786C21.2271 34.6558 21.3575 34.7763 21.3285 34.9162C21.3044 35.0319 21.1836 35.0994 21.0629 35.1042C20.947 35.1042 20.8359 35.0608 20.7248 35.0174C19.923 34.7137 19.0199 34.6703 18.1891 34.9017C17.9235 34.974 17.1362 35.0608 17.4647 34.5593C17.6675 34.2507 18.2954 34.1447 18.6335 34.0868C19.4787 33.947 20.377 34.1109 21.1015 34.5786H21.1063Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1935 36.9077C20.2466 36.9511 20.2998 37.0138 20.2804 37.0764C20.266 37.1295 20.2032 37.1536 20.1452 37.1536C20.0921 37.1536 20.0389 37.1198 19.9906 37.0957C19.6284 36.9125 19.2082 36.845 18.8073 36.9125C18.6769 36.9318 18.305 36.9318 18.4837 36.7148C18.5948 36.5798 18.8943 36.5605 19.0537 36.5508C19.4594 36.5267 19.8699 36.6521 20.1887 36.9077H20.1935Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9762 41.45C20.4543 41.2571 21.1595 40.7701 21.1063 40.5531C20.9421 40.1529 20.435 40.6785 20.1162 40.8039C19.4545 41.0643 18.8122 41.1366 18.3147 40.9919C17.5468 40.7653 17.0638 40.2059 16.9237 40.4326C16.5953 41.0016 18.4258 42.0769 19.9762 41.45Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5318 39.8154C19.7781 39.7141 20.1452 39.4633 20.1162 39.3524C20.0293 39.1451 19.7685 39.4151 19.6043 39.4826C19.2614 39.6176 18.9329 39.6562 18.6769 39.5791C18.2809 39.4633 18.0297 39.174 17.9573 39.2898C17.7883 39.5839 18.7349 40.1384 19.5318 39.8154Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.7409 44.242C34.7409 45.7271 33.5335 46.9326 32.0459 46.9326C30.5583 46.9326 29.3509 45.7271 29.3509 44.242C29.3509 42.7568 30.5583 41.5513 32.0459 41.5513C33.5335 41.5513 34.7409 42.7568 34.7409 44.242Z",
    fill: "url(#paint4_linear_6_19200)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9928 37.9733C28.6167 37.9733 25.883 40.8038 25.883 44.295C25.883 47.7861 28.6215 50.6166 31.9928 50.6166C35.364 50.6166 38.1025 47.7861 38.1025 44.295C38.1025 40.8038 35.364 37.9733 31.9928 37.9733ZM31.9928 48.2828C29.8628 48.2828 28.1386 46.4986 28.1386 44.295C28.1386 42.0913 29.8628 40.3072 31.9928 40.3072C34.1227 40.3072 35.847 42.0913 35.847 44.295C35.847 46.4986 34.1227 48.2828 31.9928 48.2828Z",
    fill: "#4F6B77"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0356 39.0438C35.2094 39.1547 35.3978 39.3283 35.3591 39.5309C35.3253 39.6948 35.1466 39.7961 34.9776 39.8009C34.8085 39.8009 34.6492 39.7382 34.4898 39.6803C33.3306 39.2415 32.0314 39.1788 30.8384 39.5164C30.452 39.6225 29.317 39.743 29.7952 39.0197C30.0898 38.5761 30.993 38.417 31.476 38.3398C32.6931 38.1373 33.9923 38.3736 35.0307 39.0487L35.0356 39.0438Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7218 42.3999C33.7991 42.4626 33.8764 42.5494 33.8474 42.6459C33.8233 42.723 33.7363 42.7616 33.6542 42.7519C33.5769 42.7471 33.5045 42.7037 33.4321 42.67C32.9104 42.4048 32.3019 42.3083 31.7271 42.4048C31.5436 42.4337 31.0026 42.4337 31.2635 42.1203C31.4228 41.9274 31.8575 41.8984 32.0894 41.8888C32.6689 41.8551 33.2678 42.0335 33.7218 42.3999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4127 48.9434C34.1034 48.6637 35.1177 47.9645 35.0404 47.6511C34.7989 47.0773 34.0744 47.8295 33.6107 48.0128C32.6544 48.3889 31.7319 48.495 31.0171 48.2828C29.9111 47.9597 29.2156 47.1496 29.0128 47.4775C28.5346 48.2973 31.1765 49.85 33.4127 48.9434Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7704 46.5855C33.1278 46.4408 33.6494 46.0791 33.6108 45.9152C33.4852 45.6162 33.1133 46.0068 32.8718 46.1033C32.3791 46.2961 31.901 46.3492 31.5339 46.2431C30.964 46.0743 30.6018 45.6596 30.5003 45.8284C30.254 46.2527 31.6209 47.0532 32.7752 46.5855H32.7704Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.17
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4381 53.5774C55.7362 48.4708 59.7691 40.6495 59.7691 31.8831C59.7691 16.4913 47.3564 4.01672 32.0411 4.01672C19.7009 4.01672 9.24912 12.1225 5.6509 23.3241C12.7701 17.6968 21.8212 16.9108 30.8239 18.8637C37.3587 20.2814 43.8307 23.0637 48.2789 28.0544C52.7272 33.0452 54.7412 40.5386 52.0124 46.6337C51.0078 48.8759 49.3995 51.2965 49.4333 53.5774H49.4381Z",
    fill: "#0D1214"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_19200",
    x1: 23.2846,
    y1: 24.3753,
    x2: 23.2846,
    y2: 18.9891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_19200",
    x1: 42.1934,
    y1: -0.0000034543,
    x2: 42.1934,
    y2: -0.0000034543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_19200",
    x1: 45.8302,
    y1: 40.0565,
    x2: 45.8302,
    y2: 36.3194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_19200",
    x1: 19.0295,
    y1: 40.0565,
    x2: 19.0295,
    y2: 36.3194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_19200",
    x1: 32.0411,
    y1: 46.9375,
    x2: 32.0411,
    y2: 41.5513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_19200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ1772Plug);
export default __webpack_public_path__ + "static/media/j1772_plug.df0fb482d1a76f8cb37e67182e8f0ad9.svg";
export { ForwardRef as ReactComponent };